import { GridRenderCellParams } from '@mui/x-data-grid';

// Kept outside columns/index.tsx: every export of that module is iterated as a grid column.
const getDiffValue = (field: string) => (params: GridRenderCellParams): number => Number(params?.row?.diff?.[field] ?? 0);

/** Higher is better (volumes, rates, revenue). */
export const isPositiveDiffGood = (field: string) => (params: GridRenderCellParams): boolean => getDiffValue(field)(params) > 0;

/** Lower is better (costs, SEO position): its evolution color is inverted. */
export const isNegativeDiffGood = (field: string) => (params: GridRenderCellParams): boolean => getDiffValue(field)(params) < 0;
